import { useMemo } from "react";
import { useMe } from "@/api/me";
import { useMerchant } from "@/providers/MerchantProvider";

export const useMerchantFeatures = () => {
  const merchant = useMerchant();
  const { data: me } = useMe();

  const features = useMemo(() => {
    return me?.merchants.find((m) => m.id === merchant)?.features ?? [];
  }, [merchant, me]);

  return features;
};
